<template>
	<div class="modal-card" style="width: auto; min-width: 680px">
		<header class="modal-card-head">
			<p class="modal-card-title">{{ activeFolderTitle }}</p>
		</header>
		<section class="modal-card-body">
			<loading v-if="loading"></loading>
			<div class="box-container" v-else>
				<div>
					<o-button variant="light" size="small" @click="Back" :disabled="pos == 0">
						<o-icon icon="angle-left"></o-icon>
					</o-button>
					<o-button
						variant="light"
						size="small"
						@click="Forward"
						:disabled="pos >= history.length - 1">
						<o-icon icon="angle-right"></o-icon>
					</o-button>
				</div>
				<div class="box-table">
					<o-table :data="items" :defaultSort="['name', 'asc']">
						<o-table-column field="Id" label="" v-slot="props">
							<div class="box-table-thumbnail">
								<img :src="GetSrc(props.row.id)" v-if="props.row.type === 'file'" />
								<o-icon icon="folder" size="medium" v-if="props.row.type === 'folder'"></o-icon>
							</div>
						</o-table-column>
						<o-table-column field="name" label="File Name" sortable v-slot="props">
							<div class="box-table-row">
								{{ props.row.name }}
							</div>
						</o-table-column>
						<o-table-column
							field="modified_by.name"
							label="Last Modified By"
							sortable
							v-slot="props">
							{{ props.row.modified_by.name }} on
							{{ moment(props.row.modified_at).format("MM/DD/YYYY h:mm") }}
						</o-table-column>
						<o-table-column field="" label="" v-slot="props">
							<div class="box-table-download">
								<o-button
									variant="light"
									@click="DoAction(props.row)"
									v-if="props.row.type === 'file' && !select">
									<o-icon icon="download"></o-icon>
								</o-button>
								<o-button
									variant="light"
									@click="Select(props.row)"
									v-if="props.row.type === 'file' && select">
									<o-icon icon="file-check"></o-icon>
								</o-button>
								<o-button
									variant="light"
									@click="DoAction(props.row)"
									v-if="props.row.type === 'folder'">
									<o-icon icon="folder-open"></o-icon>
								</o-button>
							</div>
						</o-table-column>
					</o-table>
				</div>
			</div>
		</section>
		<footer class="modal-card-foot">
			<o-button variant="light" @click="Close">Cancel</o-button>
		</footer>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted, watch } from "vue";
	import { getPage } from "@/services/utils/contentUtils";
	export default {
		props: {
			title: {
				type: String,
				default: "Folder"
			},
			folderId: {
				type: String,
				default: "0" //root
			},
			sort: {
				type: String,
				default: null
			},
			direction: {
				type: [Number, Boolean],
				default: null
			},
			limit: {
				type: [String, Number],
				default: null
			},
			select: {
				type: Boolean,
				default: false
			}
		},
		setup(props, context) {
			const $http = inject("$http");
			const $error = inject("$error");
			const moment = inject("$moment");

			const loading = ref(true);
			const items = ref([]);
			const history = ref([{ title: props.title, folderId: props.folderId }]);
			const pos = ref(0);
			const activeFolderTitle = ref(props.title);
			const activeFolderId = ref(props.folderId);

			const queryString = computed(() => {
				let qs = "";
				if (props.sort) {
					qs += "&sort=" + props.sort;
				}
				if (props.direction == 0 || props.direction == 1) {
					qs += "&direction=" + props.direction;
				}
				if (props.limit) {
					qs += "&limit=" + props.limit;
				}

				if (qs.length > 0) {
					qs = "?" + qs.substring(1);
				}
				return qs;
			});

			const GetSrc = (itemId) => {
				return process.env.VUE_APP_API + "api/v2/box/thumbnail/" + itemId;
			};

			const Select = (row) => {
				context.emit("select", row);
				Close();
			};

			const DoAction = (item, options) => {
				if (item.type == "file") {
					Download(item);
				} else GetFolder(item, options);
			};

			const GetFolder = async (row, options) => {
				if (row && history.value[pos.value + 1]?.folderId == row.id) {
					Forward();
					return;
				}
				if (!options?.firstRun) {
					pos.value += 1;
				}

				try {
					loading.value = true;
					const response = await $http.get(
						"/api/v2/box/folder/" + (row?.id || props.folderId) + queryString.value
					);
					if (row) {
						if (pos.value >= history.value.length) {
							history.value.push({
								title: row.name,
								folderId: row.id,
								items: response.data.entries
							});
						} else {
							history.value[pos.value] = {
								title: row.name,
								folderId: row.id,
								items: response.data.entries
							};
						}
						activeFolderTitle.value = row.name;
						activeFolderId.value = row.id;
					} else {
						//initial run
						history.value[pos.value]["items"] = response.data.entries;
					}
					items.value = response.data.entries;
					loading.value = false;
				} catch (err) {
					console.error(err);
					loading.value = false;
				}
			};

			const Download = async (row) => {
				try {
					const response = await $http.get("/api/v2/box/file/" + row.id + "/download", {
						responseType: "blob"
					});

					const blob = response.data;
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.setAttribute("download", row.name);

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} catch (err) {
					console.error(err);
				}
			};

			const Back = () => {
				if (pos.value >= 0) {
					pos.value -= 1;
					activeFolderTitle.value = history.value[pos.value].title;
					activeFolderId.value = history.value[pos.value].folderId;
					items.value = history.value[pos.value].items;
				}
			};
			const Forward = () => {
				if (pos.value < history.value.length) {
					pos.value += 1;
					activeFolderTitle.value = history.value[pos.value].title;
					activeFolderId.value = history.value[pos.value].folderId;
					items.value = history.value[pos.value].items;
				}
			};

			const Close = () => {
				context.emit("close");
			};

			onMounted(() => {
				GetFolder(undefined, { firstRun: true });
			});

			return {
				moment,
				loading,
				items,
				history,
				pos,
				activeFolderTitle,
				activeFolderId,
				Close,
				GetSrc,
				DoAction,
				Select,
				Back,
				Forward
			};
		}
	};
</script>
<style lang="scss" scoped>
	.box-table {
		width: 100%;
	}
	.box-promo-row {
		border: solid 1px #eee;
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		padding: 10px;
		margin: 10px 0;
	}
	.box-promo-thumbnail {
		height: 100px;
		width: 100px;
		padding: 0;
		margin-right: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.box-promo-filename {
		flex-grow: 2;
		display: flex;
		align-items: center;
	}

	.box-promo-download {
		height: 100px;
		width: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.box-table-row {
		// border: solid 1px #eee;
		// border-radius: 4px;
		// display: flex;
		// justify-content: space-between;
		// padding: 10px;
		// margin: 10px 0;
		& > td {
			padding-top: 12px;
		}
	}
	.box-table-thumbnail {
		height: 35px;
		width: 35px;
		margin-right: -10px;
		& > img {
			border-radius: 2px;
		}
	}

	.box-table-filename {
		flex-grow: 2;
		display: flex;
		align-items: center;
	}
	.box-table-download {
		// height: 100px;
		// width: 50px;
		// display: flex;
		align-items: right;
		justify-content: right;
		float: right;
	}
	.box-table {
		margin-top: 10px;
		margin-bottom: 10px;
		td {
			padding-top: 12px;
		}
	}
</style>
